import React__default from 'react';
import { EditUserProfileProvider } from './EditUserProfile/context.js';
import { EditUserProfileUI } from './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-j5GfJ6DZ.js';
import './chunks/bundle-BSUtC3cw.js';
import './chunks/bundle-BjDPDV1u.js';
import './chunks/bundle-CnQtgeX8.js';
import './chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import './chunks/bundle-idC_wVZi.js';
import './chunks/bundle-DvCKSiBl.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-ZBp236Ey.js';
import './ui/Icon.js';
import './chunks/bundle-B7LMd75S.js';
import './chunks/bundle-DloqDvm2.js';
import './chunks/bundle-BC1GKYVu.js';
import './chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';
import './ui/Input.js';
import './chunks/bundle-2OseAMr7.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-BlgLvEI8.js';
import './ui/TextButton.js';
import './chunks/bundle-CyIWMcD_.js';

var EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};

export { EditUserProfile as default };
//# sourceMappingURL=EditUserProfile.js.map
